(function() {
	'use strict';

	if(avastGlobals.detect.browser.isFirefox) {
		document.querySelector('body').classList.add('is-firefox');
	}
	else if(avastGlobals.detect.browser.isChrome) {
		document.querySelector('body').classList.add('is-chrome');
	}
	else if(avastGlobals.detect.browser.isEdge) {
		document.querySelector('body').classList.add('is-edge');
    }
    else if(avastGlobals.detect.browser.isEdgeChromium) {
		document.querySelector('body').classList.add('is-edge-chromium');
    }
	else if(avastGlobals.detect.browser.isOpera) {
		document.querySelector('body').classList.add('is-opera');
	}
	else {
		document.querySelector('body').classList.add('is-chrome');
	}
})();
